frontendApp.filter('bytes', [() => app.Utilities.formatBytes]);
